import { Identifiable, Task } from "@planzone/dto";
import { Filter } from "@planzone/dto";

import { isFilteredByResources } from "./resources";
import { isFilteredByGroups } from "./groups";
import { isFilteredByResourcesTags } from "./resourceTags";
import { isFilteredByProjectsElementsTags } from "./projectsElementsTags";

function isTaskFiltered(task: Identifiable<Task>, filter: Filter): boolean {
  return [
    isFilteredByResources,
    isFilteredByGroups,
    isFilteredByProjectsElementsTags,
    isFilteredByResourcesTags,
  ].reduce(
    (isFiltered, applyFilter) =>
      isFiltered ? isFiltered : applyFilter(task, filter),
    false,
  );
}

export { isTaskFiltered };
